import listmarkIcon from "@public/listmarkIcon.svg"
import Image from "next/image"

function BenefitItem({ header, details }: { header: string; details?: string }) {
  return (
    <div className="ml-4 mt-6">
      <div className="flex items-start gap-3">
        <Image width={20} height={20} src={listmarkIcon} alt="" className="mt-1" />
        <div className="flex flex-col">
          <div className="body--medium text-on-surface">{header}</div>
          {details && <div className="body--small text-neutral-50">{details}</div>}
        </div>
      </div>
    </div>
  )
}

export default BenefitItem
